import { MeasuredAsMetricDenominator } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/MeasuredAsField/MeasuredAsMetricDenominator';
import { CalculateRounded } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { MeasuredAsCriteriaAutoComplete } from './MeasuredAsCriteriaAutoComplete';
import { MeasuredAsMetricAutocomplete } from './MeasuredAsMetricAutocomplete';

export function MeasuredAsField() {
  return (
    <Stack direction="column" spacing={1.5} px={2} py={1.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack spacing={1} direction="row" alignItems="center">
          <CalculateRounded
            sx={{
              color: 'text.secondary',
            }}
          />
          <Typography variant="subtitle1">Measured as</Typography>
        </Stack>
        <Button
          href="https://helpcenter.enterpret.com/en/articles/8791835-quantify-query#h_de7f2fa52c"
          size="small"
          target="_blank"
        >
          Learn More
        </Button>
      </Stack>
      <Stack direction="column" spacing={1} sx={{ pl: 4 }}>
        <MeasuredAsMetricAutocomplete />
        <Typography variant="body2" color="text.secondary">
          of
        </Typography>
        <MeasuredAsCriteriaAutoComplete />
      </Stack>
      <MeasuredAsMetricDenominator sx={{ pl: 4 }} />
    </Stack>
  );
}
